import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WebHumiLogoComponent } from '@app/components/humi-design-library/humi-logo/humi-logo.component';
import { SVGImageComponent } from '@app/components/svg-image/svg-image.component';
import { AppCommonModule } from '@app/modules/common/common.module';
import { PlatformModule } from '@app/platform.module';
import { ApplicantTrackerForms } from './components';

@NgModule({
    imports: [CommonModule, FormsModule, AppCommonModule, PlatformModule, WebHumiLogoComponent, SVGImageComponent],
    declarations: [...ApplicantTrackerForms],
    exports: [...ApplicantTrackerForms],
})
export class ApplicantTrackerFormsModule {}
